// Константы для города и локали
export const CITY_COOKIE_KEY = "x-city-slug";
export const CITY_HEADER_KEY = "x-city-slug";
export const LOCALE_COOKIE_KEY = "NEXT_LOCALE";
export const LOCALE_HEADER_KEY = "x-locale";
export const DEVICE_HEADER_KEY = "x-device";

export const DEFAULT_CITY_SLUG = "almaty";